export const scrollLeaderboardsToActiveItem = () => {
    const activeItems = Array.from(document.querySelectorAll('.js-leaderboards-item.active'));

    activeItems.forEach((item) => {
        const scrollParent = item.closest('.js-scrollbar-block');

        if (scrollParent) {
            const scrollPos = item.offsetTop - scrollParent.offsetHeight * 0.5 + item.offsetHeight * 0.5;

            scrollParent.scrollTop = scrollPos;
        }
    });
};

export const updateLeaderboardsBlocks = (leaderboards, activeTeamId) => {
    const leaderboardsItems = Array.from(document.querySelectorAll('.js-leaderboards-item'));

    leaderboards.sort((a, b) => b.score - a.score);

    leaderboardsItems.forEach((item) => {
        const { teamId } = item.dataset;
        const scoreEl = item.querySelector('.js-leaderboards-item-score');
        const teamData = leaderboards.find((el) => el.id === teamId);
        const position = leaderboards.indexOf(teamData);

        if (!scoreEl || !teamData) return;

        item.style.order = position;
        const score = teamData.score || 0;

        scoreEl.innerHTML = score.toString().padStart(7, '0');

        if (typeof activeTeamId !== 'string') return;

        if (teamId === activeTeamId) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
};
